module.exports = __webpack_public_path__ + "img/feature-item-2.d3b55add.svg";